export default __webpack_public_path__ + "static/media/3.38677130.svg";